import { render, staticRenderFns } from "./IscrizioniTirFormativi.vue?vue&type=template&id=7345f9d3&scoped=true&"
import script from "./IscrizioniTirFormativi.vue?vue&type=script&lang=ts&"
export * from "./IscrizioniTirFormativi.vue?vue&type=script&lang=ts&"
import style0 from "./IscrizioniTirFormativi.vue?vue&type=style&index=0&id=7345f9d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7345f9d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
